import { Theme } from '@emotion/react';
import { SxProps } from '@mui/material';

export const orderItemTableIconSX: SxProps<Theme> = () => ({
	width: 24,
	height: 24,
	minHeight: 24,
	minWidth: 24,
	maxHeight: 24,
	maxWidth: 24,
});
